export default __webpack_public_path__ + "static/media/mainPage.4d20f283.png";